<script setup>
import {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue';
import {useForm} from "@inertiajs/inertia-vue3";
import TextInput from "@/Shared/Inputs/TextInput";
import ButtonShape from "@/Shared/ButtonShape";
import {useRecaptcha} from "@/ReCaptcha";
import {reactive, watch} from "vue";
import CloseIcon from "@/Shared/SVG/CloseIcon";
import FileIcon from "@/Shared/SVG/FileIcon";

let props = defineProps({
    open: {
        type: Boolean,
        default: false,
    },
    errors: Object,
});
const emit = defineEmits(['close']);

let newsletterSettings = reactive({
    submitNewsletterFormShow: true,
})

watch(
    () => props.open,
    () => {
        if (props.open)
        {
            useRecaptcha();
        }
    }
);

const form = useForm({
    email: '',
    // 'g-recaptcha-response': ''
});

const submit = async (event) =>  {
    // form['g-recaptcha-response'] = event.target['g-recaptcha-response'].value
    grecaptcha.reset();
    await form.post(route('subscribe'), {
        preserveScroll: true,
        onSuccess: () => {
            form.reset()
            newsletterSettings.submitNewsletterFormShow = false
        }
    });
};

</script>

<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="relative z-10">
            <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="ease-in duration-200"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div
                    class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                />
            </TransitionChild>

            <div class="fixed inset-0 z-10 overflow-y-auto">
                <div
                    class="flex min-h-full justify-center sm:p-4 text-center sm:items-center sm:p-0"
                >
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <DialogPanel
                            class="relative transform sm:rounded-2xl bg-wgn-black-3 w-full sm:max-w-3xl transition-all"
                        >
                            <div class="bg-white bg-opacity-20 sm:bg-opacity-0 px-4 py-6 sm:py-0 sm:pt-10 sm:px-10">
                                <div class="text-center">
                                    <div v-if="newsletterSettings.submitNewsletterFormShow">
                                        <div class="flex justify-between">
                                            <h4 class="text-white text-2xl">Newsletter</h4>
                                            <button @click.prevent="$emit('close')">
                                                <CloseIcon></CloseIcon>
                                            </button>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <FileIcon class="m-auto"></FileIcon>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-col m-5 sm:m-0 sm:mt-5 px-4 pt-5 pb-4 sm:px-10 sm:pt-0 sm:pb-10">
                                <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                        <div class="overflow-hidden">
                                            <div v-if="newsletterSettings.submitNewsletterFormShow">
                                                <form class="min-w-full flex flex-col space-y-3 justify-between p-1 items-center drop-shadow-none" @submit.prevent="submit">
                                                    <div class="w-full border border-[#705CFF] border-opacity-[0.24] rounded-lg drop-shadow-3xl">
                                                        <text-input v-model="form.email" class="bg-transparent border-none text-white text-opacity-70 placeholder-white placeholder-opacity-30" placeholder="Enter your email"></text-input>
                                                    </div>
                                                    <div class="g-recaptcha" data-theme="dark" :data-sitekey="$page.props.recaptcha_site_key">
                                                    </div>
                                                    <div v-if="errors.email" class="text-red-700">
                                                        {{ errors.email }}
                                                    </div>
                                                    <div v-if="errors['g-recaptcha-response']" class="text-red-700">
                                                        {{ errors['g-recaptcha-response'] }}
                                                    </div>
                                                    <div>
                                                        <button type="submit">
                                                            <ButtonShape type="blue" class="h-[50px] flex items-center drop-shadow-none">
                                                                <span>Subscribe</span>
                                                            </ButtonShape>
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                            <div v-else>
                                                <p class="text-2xl text-white italic px-12 mb-4">
                                                    Thank you for signing your email
                                                </p>
                                                <button @click.prevent="$emit('close')">
                                                    <ButtonShape type="blue">
                                                        <span>Done</span>
                                                    </ButtonShape>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
